import { ChantContext } from '../../gregorio-chant/ChantContext';
import { Glyph } from '../glyphs/Glyph';
import { ChantLayoutElement } from '../layout/ChantLayoutElement';
import { calculateHeightPositionFromPitch } from '../utils';
import { GlyphVisualizer } from './GlyphVisualizer';
import { VisualizerHelper } from './VisualizerHelper';

export class BarBrace extends GlyphVisualizer {
  constructor(context: ChantContext) {
    super(context, new Glyph('BarBrace', context.gabcFont, context.gabcGlyphSize), context.gabcColor);
    this._textAnchor = 'middle';
    this.bounds.setY(calculateHeightPositionFromPitch(this._context, 9));
  }

  public performLayout(prevElements: ChantLayoutElement[]): void {
    const bar = VisualizerHelper.findLastBar(prevElements);
    if (bar) {
      this.bounds.setX(bar.bounds.width / 2);
    }
  }
}
